import { TimeService_timeServiceGetGetTime } from '@festina/moneyout-general-types/moneyout-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchMoneyOutTime = TimeService_timeServiceGetGetTime.useQuery
